import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import { useNotification } from "~hooks/useNotification.ts";
import type { CreateSeasonStageModel } from "~pages/SeasonStages/types/seasonStageModel.ts";
import type { StageResponse } from "~types/stage.ts";

export const useCreateSeasonStage = () => {
  const { sport, organizationId, seasonId } = useParams();
  const request = useApi();
  const queryClient = useQueryClient();
  const { formatMessage } = useIntl();
  const notification = useNotification();

  return useMutation<StageResponse, Error, CreateSeasonStageModel>({
    mutationFn: async ({ stageCode, ...stageData }) =>
      await request<StageResponse>(`${sport}/o/${organizationId}/seasons/${seasonId}/stages`, {
        method: "POST",
        body: {
          stageCode,
          ...stageData,
        },
      }),
    onSuccess: async () => {
      notification.success({
        message: formatMessage({ id: "stage.add.success" }),
        placement: "bottomRight",
      });

      await queryClient.invalidateQueries({ queryKey: ["seasonStages", sport, organizationId, seasonId] });
    },
  });
};
